export const GLOBAL_FILTER_CACHE_KEY = "GLOBAL_FILTERS";

export const GLOBAL_FILTERS_STORAGE_KEY = "globalFilters";

export const COMMUNITY_SEARCH_CACHE_KEY = "COMMUNITY_SEARCH";

export const COMMUNITY_SEARCH_STORAGE_KEY = "communitySearch";
